module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "signInAndSignUp"
    }
  }, [_c('MyDialog', {
    attrs: {
      "visible": _vm.signUpDialogVisible
    }
  }, [_c('div', {
    staticClass: "ct"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('label', {
    class: {
      active: _vm.actionType == 'signUp'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actionType),
      expression: "actionType"
    }],
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "signUp"
    },
    domProps: {
      "checked": _vm._q(_vm.actionType, "signUp")
    },
    on: {
      "__c": function($event) {
        _vm.actionType = "signUp"
      }
    }
  }), _vm._v("注册")]), _vm._v(" "), _c('label', {
    class: {
      active: _vm.actionType == 'signIn'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actionType),
      expression: "actionType"
    }],
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "signIn"
    },
    domProps: {
      "checked": _vm._q(_vm.actionType, "signIn")
    },
    on: {
      "__c": function($event) {
        _vm.actionType = "signIn"
      }
    }
  }), _vm._v("登入")])]), _vm._v(" "), (_vm.actionType == 'signUp') ? _c('div', {
    staticClass: "signUp"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.signUp($event)
      }
    }
  }, [_c('div', {
    staticClass: "formRow"
  }, [_c('label', [_vm._v("账号:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.username),
      expression: "formData.username"
    }],
    attrs: {
      "type": "text",
      "placeholder": "账号(字母、数字、特殊符号，6—16位)"
    },
    domProps: {
      "value": (_vm.formData.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.username = $event.target.value
      }
    }
  }), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "formRow"
  }, [_c('label', [_vm._v("密码:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.password),
      expression: "formData.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "密码(字母、数字、特殊符号，6—16位，至少2种)"
    },
    domProps: {
      "value": (_vm.formData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "formActions",
    on: {
      "click": _vm.isValidUsername
    }
  }, [_c('input', {
    attrs: {
      "type": "submit",
      "value": "注册"
    },
    on: {
      "click": _vm.isValidPassword
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.actionType == 'signIn') ? _c('div', {
    staticClass: "signIn"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.signIn($event)
      }
    }
  }, [_c('div', {
    staticClass: "formRow"
  }, [_c('label', [_vm._v("账号:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.username),
      expression: "formData.username"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名"
    },
    domProps: {
      "value": (_vm.formData.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "formRow"
  }, [_c('label', [_vm._v("密码:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.password),
      expression: "formData.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.formData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "formActions"
  }, [_c('input', {
    attrs: {
      "type": "submit",
      "value": "登入"
    }
  })])])]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.1@vue-loader/lib/template-compiler?{"id":"data-v-37762888"}!./~/_vue-loader@12.2.1@vue-loader/lib/selector.js?type=template&index=0!./src/components/SignInAndSignUp.vue
// module id = 79
// module chunks = 1